/**
 * Selector for the DOM element of a paid break exception field by shift date.
 * This must match the data attributes set on PaidBreakExceptionFormField.
 */
export function getPaidBreakExceptionFieldSelector(shiftDate: string): string {
  return `[data-paid-break-exception-field][data-shift-date="${shiftDate}"]`;
}
